import React from "react";

export default function renderIcon({
  width = 33.29,
  height = 35.31,
  color = "#848484",
}) {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="11"
        cy="11"
        r="11"
        transform="matrix(-1 0 0 1 22.5 0.5)"
        fill="black"
        fill-opacity="0.4"
        stroke="white"
      />
      <path
        d="M8.16586 11.1505L14.1059 6.03329C14.2051 5.94767 14.3369 5.8999 14.474 5.8999C14.6111 5.8999 14.7429 5.94767 14.842 6.03329L14.847 6.03931C14.8953 6.08069 14.9338 6.13054 14.9601 6.18582C14.9864 6.2411 15 6.30065 15 6.36083C15 6.42102 14.9864 6.48057 14.9601 6.53585C14.9338 6.59113 14.8953 6.64098 14.847 6.68235L9.25496 11.5014L14.847 16.3175C14.8953 16.3588 14.9338 16.4087 14.9601 16.464C14.9864 16.5192 15 16.5788 15 16.639C15 16.6992 14.9864 16.7587 14.9601 16.814C14.9338 16.8693 14.8953 16.9191 14.847 16.9605L14.842 16.9665C14.7429 17.0521 14.6111 17.0999 14.474 17.0999C14.3369 17.0999 14.2051 17.0521 14.1059 16.9665L8.16586 11.8493C8.11346 11.8043 8.07173 11.7501 8.04322 11.69C8.0147 11.6299 8 11.5653 8 11.4999C8 11.4345 8.0147 11.3699 8.04322 11.3098C8.07173 11.2497 8.11346 11.1955 8.16586 11.1505Z"
        fill="white"
      />
    </svg>
  );
}
